import { LeadStatus } from "./Lead";
import { DefaultResponseWithData } from "./system";

export enum DropOffSlot {
  AllDay = 0,
  AM = 1,
  PM = 2,
}

export interface IDropOffLeadRow {
  id: string;
  vehicleId: string;
  vrm: string;
  combinedMake: string | null;
  combinedModel: string | null;
  source: string | null;
  website: number;
  postcode: string | null;
  status: LeadStatus;
  created: string;
  scheduledCollectionOn: string | null;
  scheduledCollectionSlot: DropOffSlot;
  collectedOn: string | null;
  hasAlert: boolean;
  isVan: boolean;
}

export interface IAllocateDropOffRequest {
  scheduledOn: string;
  slot: DropOffSlot;
}

export interface IDropOffLeadRowsResponse extends DefaultResponseWithData<IDropOffLeadRow[]> {}
export interface IDropOffLeadRowResponse extends DefaultResponseWithData<IDropOffLeadRow> {}

export type DropOffSort = "Oldest" | "Newest";
export type DropOffDayRange = 1 | 3 | 5 | 7;

export interface IDropOffDragItem {
  leadId: string;
  currentScheduledOn: string | null;
  currentSlot: DropOffSlot | null;
}
